import { createSlice } from "@reduxjs/toolkit";
import { fetchProject } from "../actions/projectAction"; // ajuste o path se necessário
import { REHYDRATE } from "redux-persist";

/* --- Estado inicial alinhado à tabela project --- */
const initialState = {
  data: {
    id: 0,
    name: "",
    type: "",
    description: "",
    partners: "",
    start: "",
    status: "",
    contact: "",
    image: "",
    created_user_id: 0,
    created_user_name: "",
    created_date: "",
    updated_user_id: 0,
    updated_user_name: "",
    updated_date: "",
  },
  isLoading: false,
  error: false,
};

export const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    project: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchProject.rejected, (state) => {
        state.isLoading = false;
        state.error = true;
      })
      /* Suporte a reidratação via redux‑persist */
      .addCase(REHYDRATE, (state) => {
        const { data } = state;
        state.isLoading = false;
        state.data = data;
      });
  },
});

export const { project } = projectSlice.actions;
export default projectSlice.reducer;
